import listActions from 'src/modules/soundTitle/list/soundTitleListActions';
import SoundTitleService from 'src/modules/soundTitle/SoundTitleService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'SOUND_TITLE_UNARCHIVE';

const soundTitleUnarchiveActions = {
  UNARCHIVE_STARTED: `${prefix}_UNARCHIVE_STARTED`,
  UNARCHIVE_SUCCESS: `${prefix}_UNARCHIVE_SUCCESS`,
  UNARCHIVE_ERROR: `${prefix}_UNARCHIVE_ERROR`,

  UNARCHIVE_ALL_STARTED: `${prefix}_UNARCHIVE_ALL_STARTED`,
  UNARCHIVE_ALL_SUCCESS: `${prefix}_UNARCHIVE_ALL_SUCCESS`,
  UNARCHIVE_ALL_ERROR: `${prefix}_UNARCHIVE_ALL_ERROR`,

  doUnarchive: (id) => async (dispatch) => {
    try {
      dispatch({
        type: soundTitleUnarchiveActions.UNARCHIVE_STARTED,
      });

      await SoundTitleService.unarchiveAll([id]);

      dispatch({
        type: soundTitleUnarchiveActions.UNARCHIVE_SUCCESS,
      });

      Message.success(
        i18n('entities.soundTitle.unarchive.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/sound-title');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: soundTitleUnarchiveActions.UNARCHIVE_ERROR,
      });
    }
  },

  doUnarchiveAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type:
          soundTitleUnarchiveActions.UNARCHIVE_ALL_STARTED,
      });

      await SoundTitleService.unarchiveAll(ids);

      dispatch({
        type:
          soundTitleUnarchiveActions.UNARCHIVE_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.soundTitle.unarchiveAll.success'),
      );

      getHistory().push('/sound-title');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type:
          soundTitleUnarchiveActions.UNARCHIVE_ALL_ERROR,
      });
    }
  },
};

export default soundTitleUnarchiveActions;
